import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../api.service';
import { Course } from '../course.model';
import { CourseSession } from '../course-session.model';
import { LandingPageService } from '../landing-page.service';
import moment from "moment";

@Component({
    selector: 'app-landing-page-course-session',
    templateUrl: './landing-page-course-session.component.html',
    styleUrls: ['./landing-page-course-session.component.scss']
})
export class LandingPageCourseSessionComponent implements OnInit {
    @Input() course: Course;
    @Input() session: CourseSession;
    
    isLoading: boolean = false;
    isLoaded: boolean = false;
    loadingError: string = '';
    errorMessage: string = '';
    display: boolean = false;
    isOneDaySession: boolean = true;

    constructor(
        private apiService: ApiService,
        private landingPageService: LandingPageService,
    ) { }

    ngOnInit(): void {
        this.get()
    }

    get() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.loadingError = '';

        this.apiService.getCourseSession(this.course, this.session).subscribe(
            (data) => {
                this.session = new CourseSession(data);
                this.isOneDaySession = moment(this.session.startDate, 'MM/D/YYYY').isSame(moment(this.session.endDate, 'MM/D/YYYY'), 'day');
                this.isLoaded = true;
                this.isLoading = false;
            },
            (error) => {
                this.isLoaded = true;
                this.isLoading = false;
                this.loadingError = error;
            }
        );
    }


    open(url){
        window.open(url, "_blank");
    }

    openDocebo(){
        window.open(`/dashboard/lms/${this.session.integrations.docebo.applicationId}`, "_blank");
    }

    openZoom(){
        console.log(`open zoom`)
        // window.open(`/dashboard/lms/${this.session.integrations.zoom.applicationId}`, "_blank");
    }

    get isOneDayEvent (){
        return this.landingPageService.isOneDayEvent;
    }
}
